$(document).ready(function(){
	// time	= parseInt($("#defaultCountdown.countdown").html());
	// var newYear = new Date();
	if(new Date()>new Date($.cookie("time")))
	{
		// $.cookie("time", null, { path: "/" });
		$.removeCookie("time", { path: "/" });
	}
	if($(".coupon-for-amother .button_text").length>0)
	{
		time	= parseInt($(".coupon-for-amother .button_text").attr("id"));
		var newYear = new Date();
		newYear.setMinutes(newYear.getMinutes() + time);
		href_url	= $(".shop-btn").attr("href");
		$(".shop-btn").attr("href", href_url+"?db="+Number(newYear));
		$.cookie("time", newYear, { path: "/" });
	}
	/* if($(".countdown#defaultCountdown").length>0){
		if(!$.cookie("time") || $.cookie("time") == "null")
		{
			currentHref = window.location.href;
			t = currentHref.split('?db=');
			if (t.length > 1) {
				newYear = new Date(parseInt(t[1],10));
				$.cookie("time", newYear, { path: "/" });
			}
		}
	} */
	// console.log(newYear);
	// newYear.setMinutes(newYear.getMinutes() + time);
	// console.log(newYear);
	fun_countdown	= function(){
		// console.log(new Date());
		// console.log(new Date($.cookie("time")));
		cookie_time	= new Date($.cookie("time"));
		$('.time_left').countdown({until: cookie_time});
		$('#defaultCountdown').countdown({until: cookie_time});
		$(".previewbar").show();
		$('#defaultCountdown').show();
	}
	/* $(".button_text").click(function()
	{
		// console.log(this); return false;
		time	= parseInt(this.id);
		var newYear = new Date();
		newYear.setMinutes(newYear.getMinutes() + time);
		$.cookie("time", newYear, { path: "/" });
		fun_countdown();
		$(".coupon-for-amother").hide();
	}); */
	// console.log($(".coupon-for-amother .button_text").length);
	if($(".countdown#defaultCountdown").length>0)
	{
		if(!$.cookie("time") || $.cookie("time") == "null")
		{
			currentHref = window.location.href;
			ct = currentHref.split('?db=');
			if (ct.length > 1) {
				newYear = new Date(parseInt(ct[1],10));
				$.cookie("time", newYear, { path: "/" });
			}
		}
	}
	if(!$.cookie("time") || $.cookie("time") == "null")
	{
		if($(".coupon-for-amother .button_text").length>0)
		{
			time	= parseInt($('#defaultCountdown').attr("time"));
			var newYear = new Date();
			newYear.setMinutes(newYear.getMinutes() + time);
			$.cookie("time", newYear, { path: "/" });
		} else if($(".countdown#defaultCountdown").length>0){
			if(!$.cookie("time") || $.cookie("time") == "null")
			{
				currentHref = window.location.href;
				ct = currentHref.split('?db=');
				if (ct.length > 1) {
					newYear = new Date(parseInt(ct[1],10));
					$.cookie("time", newYear, { path: "/" });
				}
			}
		}
	}
	if($.cookie("time") && $.cookie("time") != "null")
	{
		fun_countdown();
	}
	$(".coupon-for-amother").show();
});